// DRAWOLA:CUSTOM-START export-completion
export type ExportFormat = "json" | "png" | "svg" | "clipboard";
export type ExportOutcome = "succeeded" | "failed" | "cancelled";
export type ExportObserver = (
  format: ExportFormat,
) => ((outcome: ExportOutcome) => void) | void;
/** Isolate optional observers and notify one terminal export result. */
export const startExportOperation = (
  observer: ExportObserver | undefined,
  format: ExportFormat,
): ((outcome: ExportOutcome) => void) => {
  let notify: ReturnType<ExportObserver>;
  try {
    notify = observer?.(format);
  } catch {
    /* Observers cannot block exports. */
  }
  let ended = false;
  return (outcome) => {
    if (ended) {
      return;
    }
    ended = true;
    try {
      notify?.(outcome);
    } catch {
      /* Preserve the underlying export result. */
    }
  };
};
// DRAWOLA:CUSTOM-END
